import Hero from './components/Hero';
import About from './components/About';
import Testimonials from './components/Testimonials';
import HowItWorks from './components/HowItWorks';
import Payment from './components/Payment';
import ImportDelivery from './components/ImportDelivery';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <About />
      <Testimonials />
      <HowItWorks />
      <Payment />
      <ImportDelivery />
      <Contact />
      <Footer />
    </div>
  );
}
